import { render, staticRenderFns } from "./departmentTable.vue?vue&type=template&id=4e9b07a8&scoped=true&"
import script from "./departmentTable.vue?vue&type=script&lang=js&"
export * from "./departmentTable.vue?vue&type=script&lang=js&"
import style0 from "./departmentTable.vue?vue&type=style&index=0&id=4e9b07a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b07a8",
  null
  
)

export default component.exports